<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        variant="danger"
        :show="alertErrors.length > 0"
        class="mb-0"
      >
        <div
          v-for="(row, index) in alertErrors"
          :key="index"
          class="alert-body"
        >
          <feather-icon

            icon="InfoIcon"
            class="mr-50"
          />
          {{ row }}
        </div>
      </b-alert>
      <b-card
        aria-hidden="true"
        class="mb-0"
      >
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- User Info: Input Fields -->
          <b-form
            @submit.prevent="handleSubmit(onSubmit)"
          >
            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_CLIENT_INFO') }} - {{ $t('DEBTIA_GENERAL') }}</h4></b-col>
              <!-- Field: Full Name -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Name"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_NAME')"
                    label-for="full-name"
                  >
                    <b-form-input
                      id="full-name"
                      v-model="clientData.name"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- Field: Client Type -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_CLIENT_TYPE')"
                  label-for="client-type"
                >
                  <v-select
                    v-model="clientData.type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="typeOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="client-type"
                    :value="'person'"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: CVR -->
              <b-col
                v-if="clientData.type !== 'person'"
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="CVR"
                  rules="required|integer|length:8"
                >
                  <b-form-group
                    :label="$t('DEBTIA_CVRCPR')"
                    label-for="cvrcpr"
                  >
                    <b-form-input
                      id="cvrcpr"
                      v-model="clientData.cvrcpr"
                      :state="getValidationState(validationContext)"
                      trim
                      maxlength="8"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- Field: CPR -->
              <b-col
                v-if="clientData.type === 'person'"
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_CPR')"
                  label-for="cpr"
                >
                  <cleave
                    id="cpr"
                    v-model="clientData.cpr"
                    class="form-control"
                    :raw="false"
                    :options="options.cprDelimiter"
                  />
                </b-form-group>
              </b-col>
              <!-- Field: TERMSHEETCODE -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  class="classformgroup"
                  :label="$t('DEBTIA_TERMSHEETCODE')"
                  label-for="debtor-login-status"
                >
                  <v-select
                    v-model="clientData.termSheetCode"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="termSheetCodeOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="debtor-login-status"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="clientData.type !== 'person'">
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_VAT_EXEMPTION') }}</h4></b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-checkbox
                  v-model="clientData.vat_exempted"
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <hr>

            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_CLIENT_INFO') }} - {{ $t('DEBTIA_BANK_INFORMATION') }}</h4></b-col>

              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_BANK_BRANCH_NO')"
                  label-for="bankBranchNo"
                >
                  <b-form-input
                    id="bankBranchNo"
                    v-model="clientData.bankBranchNo"
                    trim
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_BANK_ACCOUNT_NO')"
                  label-for="bankAccountNo"
                >
                  <b-form-input
                    id="bankAccountNo"
                    v-model="clientData.bankAccountNo"
                    trim
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_IBAN')"
                  label-for="iban"
                >
                  <b-form-input
                    id="iban"
                    v-model="clientData.iban"
                    trim
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_SWIFTCODE')"
                  label-for="swiftCode"
                >
                  <b-form-input
                    id="swiftCode"
                    v-model="clientData.swiftCode"
                    trim
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <hr>

            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_CLIENT_INFO') }} - {{ $t('DEBTIA_CONTACT_INFO') }}</h4></b-col>

              <!-- Field: Contact Person -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_CONTACT_PERSON')"
                  label-for="contact-person"
                >
                  <b-form-input
                    id="contact-person"
                    v-model="clientData.contact_person"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Phone -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Phone"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_PHONE')"
                    label-for="phone"
                  >
                    <b-form-input
                      id="phone"
                      v-model="clientData.phone"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Billing Email -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-group
                    :label="$t('DEBTIA_BILLING_EMAIL')"
                    label-for="billing-email"
                  >
                    <b-form-input
                      id="billing-email"
                      v-model="clientData.billing_email"
                      type="email"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <hr>

            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_CLIENT_INFO') }} - {{ $t('DEBTIA_ADDRESS') }}</h4></b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="House Number"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_HOUSE_NUMBER')"
                    label-for="house-number"
                  >
                    <b-form-input
                      id="house-number"
                      v-model="clientData.address.house_number"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Road Name"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_ROAD_NAME')"
                    label-for="road-name"
                  >
                    <b-form-input
                      id="road-name"
                      v-model="clientData.address.road_name"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Place -->
              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_PLACE_NAME')"
                  label-for="place"
                >
                  <b-form-input
                    id="place"
                    v-model="clientData.address.place"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Zipcode -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Zip Code"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_ZIP_CODE')"
                    label-for="zip-code"
                  >
                    <b-form-input
                      id="zip-code"
                      v-model="clientData.address.zip_code"
                      :state="getValidationState(validationContext)"
                      trim
                      @change="getCityName('standard_address', $event)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: City -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="City"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_CITY')"
                    label-for="city"
                  >
                    <b-form-input
                      id="city"
                      v-model="clientData.address.city"
                      :state="getValidationState(validationContext)"
                      trim
                      @change="getZipCode('standard_address', $event)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Country -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Country"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_COUNTRY')"
                    label-for="country"
                  >
                    <v-select
                      v-model="clientData.address.country_id"
                      :disabled="busy"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="countries"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="select-country"
                      :value="'Select Country'"
                    >
                      <template
                        #selected-option-container="{ option }"
                      >
                        <div class="vs__selected">
                          {{ $t(option.label) }}</div>
                      </template>
                      <template
                        slot="option"
                        slot-scope="option"
                      >
                        {{ $t(option.label) }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

            </b-row>

            <b-button
              v-if="addBillingAddressBtn === false"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="addBillingAddress"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>{{ $t('DEBTIA_ADD_NEW_BILLING_ADDRESS') }}</span>
            </b-button>
            <hr
              v-if="clientBillingAddressData === true"
            >
            <b-row
              v-if="clientBillingAddressData === true"
            >
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_BILLING_ADDRESS') }}</h4></b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_HOUSE_NUMBER')"
                  label-for="billing-house-number"
                >
                  <b-form-input
                    id="billing-house-number"
                    v-model="clientData.billing_address.house_number"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_ROAD_NAME')"
                  label-for="billing-road-name"
                >
                  <b-form-input
                    id="billing-road-name"
                    v-model="clientData.billing_address.road_name"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Place -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_PLACE_NAME')"
                  label-for="billing-place"
                >
                  <b-form-input
                    id="billing-place"
                    v-model="clientData.billing_address.place"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Zipcode -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_ZIP_CODE')"
                  label-for="billing-zip-code"
                >
                  <b-form-input
                    id="billing-zip-code"
                    v-model="clientData.billing_address.zip_code"
                    trim
                    @change="getCityName('billing_address', $event)"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: City -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_CITY')"
                  label-for="billing-city"
                >
                  <b-form-input
                    id="billing-city"
                    v-model="clientData.billing_address.city"
                    trim
                    @change="getZipCode('billing_address', $event)"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Country -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_COUNTRY')"
                  label-for="billing-country"
                >
                  <v-select
                    v-model="clientData.billing_address.country_id"
                    :disabled="busy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="countries"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="select-country"
                    :value="'Select Country'"
                  >
                    <template
                      #selected-option-container="{ option }"
                    >
                      <div class="vs__selected">
                        {{ $t(option.label) }}</div>
                    </template>
                    <template
                      slot="option"
                      slot-scope="option"
                    >
                      {{ $t(option.label) }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

            </b-row>

            <hr>

            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_CLIENT_INFO') }} - {{ $t('DEBTIA_LOGIN') }}</h4></b-col>
              <!-- Field: Status -->
              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_LOGIN')"
                  label-for="login-status"
                >
                  <v-select
                    v-model="clientData.loginStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="loginOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="login-status"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Username -->
              <b-col
                v-if="orderClientData.username === undefined"
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Username"
                  data-vv-validate-on="blur"
                  rules="required|alpha-num"
                >
                  <b-form-group

                    :label="$t('DEBTIA_USERNAME')"
                    label-for="username"
                  >
                    <b-form-input
                      id="username"
                      v-model="clientData.username"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    <span
                      v-if="!validateUsername"
                      style="color:#ea5455"
                    >
                      Username is not valid
                    </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="orderClientData.username !== undefined"
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="Username"
                  data-vv-validate-on="blur"
                  rules="required|alpha-num"
                >
                  <b-form-group

                    :label="$t('DEBTIA_USERNAME')"
                    label-for="username"
                  >
                    <b-form-input
                      id="username"
                      v-model="clientData.username"
                      :state="getValidationState(validationContext)"
                      trim
                      readonly
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    <span
                      v-if="!validateUsername"
                      style="color:#ea5455"
                    >
                      Username is not valid
                    </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <hr>

            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_ORDER_DETAILS') }}</h4></b-col>
              <b-col
                cols="6"
                md="6"
              >
                <table
                  class="client-details-table"
                >
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_ORDER_ID') }}</td>
                    <td class="right-values item-padding">
                      {{ orderData.no }}
                    </td>
                  </tr>
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_ORDER_DATE') }}</td>
                    <td class="right-values item-padding">
                      {{ orderData.orderDate }}
                    </td>
                  </tr>
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_SALESPERSON') }}</td>
                    <td class="right-values item-padding">
                      {{ orderData.salespersonCode }}
                    </td>
                  </tr>
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_PROVISIONED_SALESPERSON') }}</td>
                    <td class="right-values item-padding">
                      {{ orderData.Salesperson2Code }}
                    </td>
                  </tr>
                </table>
              </b-col>
              <b-col
                cols="6"
                md="6"
              />
            </b-row>
            <hr>
            <b-table
              ref="roles"
              class="position-relative"
              :fields="productsTableFields"
              :items="orderProductsData"
            >
              <template #cell(unitPrice)="data">
                {{ (data.item.unitPrice) ? formatCurrency(data.item.unitPrice) : 0 }}
              </template>
              <template #cell(lineAmount)="data">
                {{ (data.item.lineAmount) ? formatCurrency(data.item.lineAmount) : 0 }}
              </template>
            </b-table>
            <hr>

            <b-row>
              <b-col
                cols="6"
                md="6"
              />
              <b-col
                cols="6"
                md="6"
              >
                <table
                  class="client-details-table"
                >
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_SUB_TOTAL') }}</td>
                    <td class="right-values item-padding">
                      {{ (orderData.totalPriceAmount) ? formatCurrency(orderData.totalPriceAmount) : 0 }}
                    </td>
                  </tr>
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_VAT') }}</td>
                    <td class="right-values item-padding">
                      {{ (orderData.totalVatAmount) ? formatCurrency(orderData.totalVatAmount) : 0 }}
                    </td>
                  </tr>
                  <tr
                    class="business-item"
                  >
                    <td class="left-item-padding">
                      {{ $t('DEBTIA_TOTAL') }}</td>
                    <td class="right-values item-padding">
                      {{ (orderData.totalAmount) ? formatCurrency(orderData.totalAmount) : 0 }}
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
            <br>
            <!-- Action Buttons -->
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
            >
              {{ $t('DEBTIA_SERVICE_CALL_COMPLETE') }}
            </b-button>
            <b-button
              v-b-modal.modal-role
              variant="outline-secondary"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="deleteOrder()"
            >
              {{ $t('DEBTIA_CANCEL_ORDER') }}
            </b-button>
          </b-form>

        </validation-observer>
        <delete-order-modal
          :order-data="orderData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getDetails"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BAlert,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BOverlay,
  BButton,
  BFormInvalidFeedback,
  BFormCheckbox,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required, alphaNum, email } from '@validations'
import router from '@/router'
import axios from '@axios'
import i18n from '@/libs/i18n'
import constants from '@/app-configs/constants'
import store from '@/store'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import countries from '@/countries'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import clientStoreModule from '../client/clientStoreModule'
import DeleteOrderModal from './DeleteOrderModal.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Cleave,
    BAlert,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BButton,
    vSelect,
    BFormInvalidFeedback,
    BFormCheckbox,
    BTable,
    DeleteOrderModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      busy: false,
      countries,
      required,
      alphaNum,
      email,
      alertErrors: [],
      snowOption: {
        theme: 'snow',
      },
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      loader: true,
      orderData: {},
      termSheetCodeLoader: false,
      termSheetCodeOptions: [],
      clientData: {
        id: 0,
        name: '',
        email: '',
        type: '',
        cvrcpr: '',
        cpr: '',
        contact_person: '',
        phone: '',
        billing_email: '',
        username: '',
        vat_exempted: true,
        bc_creditor_id: '',
        loginStatus: true,
        bankBranchNo: '',
        bankAccountNo: '',
        iban: '',
        swiftCode: '',
        termSheetCode: '',
        address: {
          road_name: null,
          house_number: null,
          place: null,
          zip_code: null,
          city: null,
          country_id: 247,
        },
        billing_address: {},
        order: {},
      },
      validateUsername: true,
      address: {
        road_name: null,
        house_number: null,
        place: null,
        zip_code: null,
        city: null,
        country_id: 247,
      },
      billing_address: {
        road_name: null,
        house_number: null,
        place: null,
        zip_code: null,
        city: null,
        country_id: null,
      },
      nextTodoId: 2,
      orderProductsData: [],
      orderClientData: {},
      subTotal: 0,
      vat: 0,
      total: 0,
      options: {
        cprDelimiter: {
          delimiters: ['-'],
          blocks: [6, 4],
          uppercase: true,
        },
      },
      addBillingAddressBtn: true,
      clientBillingAddressData: true,
      defaultCurrency: localStorage.getItem('defaultCurrency'),
    }
  },
  setup(props) {
    const loginOptions = [
      { label: 'Allowed', value: '1' },
      { label: 'Not Allowed', value: '0' },
    ]
    const loader = false
    const {
      refFormObserver,
      getValidationState,
    } = formValidation(props.clientData)

    const typeOptions = [
      { label: 'Person', value: 'person' },
      { label: 'Sole Proprietorship', value: 'sole-proprietorship' },
      { label: 'Capital Company', value: 'capital-company' },
    ]

    return {
      refFormObserver,
      getValidationState,
      loginOptions,
      loader,
      typeOptions,
    }
  },
  computed: {
    productsTableFields() {
      return [
        { key: 'deferralCode', sortable: true, label: i18n.t('DEBTIA_PRODUCT') },
        { key: 'description', sortable: true, label: i18n.t('DEBTIA_DESCRIPTION') },
        { key: 'unitPrice', sortable: true, label: i18n.t('DEBTIA_PRICE') },
        { key: 'quantity', sortable: true, label: i18n.t('DEBTIA_QUANTITY') },
        { key: 'lineDiscountAmount', label: i18n.t('DEBTIA_DISCOUNT') },
        { key: 'lineAmount', label: i18n.t('DEBTIA_TOTAL_PRICE') },
      ]
    },
  },
  created() {
    this.getDetails()
    this.getTermsheetCodes()
  },
  methods: {
    addBillingAddress() {
      this.addBillingAddressBtn = true
      this.clientBillingAddressData = true
    },
    getCityName(type, event) {
      axios.get(`settings/get-city-name-by-code?code=${event}`)
        .then(response => {
          if (type === 'standard_address') {
            if (response.data.data.city_name !== null) {
              this.clientData.address.city = response.data.data.city_name
            }
          }
          if (type === 'billing_address') {
            if (response.data.data.city_name !== null) {
              this.clientData.billing_address.city = response.data.data.city_name
            }
          }
        }).catch(error => {
          console.log(error)
        })
    },
    getZipCode(type, event) {
      axios.get(`settings/get-zip-code-by-city-name?city=${event}`)
        .then(response => {
          if (type === 'standard_address') {
            if (response.data.data.zip_code !== null) {
              this.clientData.address.zip_code = response.data.data.zip_code
            }
          }
          if (type === 'billing_address') {
            if (response.data.data.zip_code !== null) {
              this.clientData.billing_address.zip_code = response.data.data.zip_code
            }
          }
        }).catch(error => {
          console.log(error)
        })
    },
    async getDetails() {
      this.orderId = router.currentRoute.params.id
      this.loader = true
      const orderDetails = await axios.get(`${constants.baseUrl}/clients/get-order-details?no=${this.orderId}`).catch(error => {
        if (error.response.status === 404) {
          this.$router.push('/orders')
        }
        this.alertErrors = []
        // this.alertErrors.push(...error.data.message)
        // console.log('error**', error)
        this.loader = false
      })

      if (orderDetails.status) {
        this.loader = true
        this.clientData.name = typeof orderDetails.data.data.data.client.name !== 'undefined' ? orderDetails.data.data.data.client.name : ''
        this.clientData.email = typeof orderDetails.data.data.data.client.email !== 'undefined' ? orderDetails.data.data.data.client.email : ''
        this.clientData.phone = typeof orderDetails.data.data.data.client.phone !== 'undefined' ? orderDetails.data.data.data.client.phone : ''
        this.clientData.cvrcpr = typeof orderDetails.data.data.data.client.cvrcpr !== 'undefined' ? orderDetails.data.data.data.client.cvrcpr : ''
        this.clientData.cpr = typeof orderDetails.data.data.data.client.cpr !== 'undefined' ? orderDetails.data.data.data.client.cpr : ''
        this.clientData.contact_person = typeof orderDetails.data.data.data.client.contact_person !== 'undefined' ? orderDetails.data.data.data.client.contact_person : ''
        this.clientData.bankBranchNo = typeof orderDetails.data.data.data.client.bankBranchNo !== 'undefined' ? orderDetails.data.data.data.client.bankBranchNo : ''
        this.clientData.bankAccountNo = typeof orderDetails.data.data.data.client.bankAccountNo !== 'undefined' ? orderDetails.data.data.data.client.bankAccountNo : ''
        this.clientData.iban = typeof orderDetails.data.data.data.client.iban !== 'undefined' ? orderDetails.data.data.data.client.iban : ''
        this.clientData.swiftCode = typeof orderDetails.data.data.data.client.swiftCode !== 'undefined' ? orderDetails.data.data.data.client.swiftCode : ''
        this.orderClientData = orderDetails.data.data.data.client.length === 0 ? {} : orderDetails.data.data.data.client
        this.orderData = orderDetails.data.data.data.order
        this.orderProductsData = orderDetails.data.data.data.order.salesOrderLines
        this.clientData.id = typeof orderDetails.data.data.data.client.id === 'undefined' ? 0 : orderDetails.data.data.data.client.id
        this.clientData.name = orderDetails.data.data.data.debtor.displayName !== '' ? orderDetails.data.data.data.debtor.displayName : this.clientData.name
        this.clientData.type = orderDetails.data.data.data.debtor.customerType !== '' ? orderDetails.data.data.data.debtor.customerType.toLowerCase() : this.clientData.type
        this.clientData.type = this.clientData.type === 'company' ? 'capital-company' : this.clientData.type
        this.clientData.cpr = orderDetails.data.data.data.debtor.cprNo !== '' ? orderDetails.data.data.data.debtor.cprNo : this.clientData.cpr
        this.clientData.cvrcpr = orderDetails.data.data.data.debtor.taxRegistrationNumber !== '' ? orderDetails.data.data.data.debtor.taxRegistrationNumber : this.clientData.cvrcpr
        this.clientData.contact_person = orderDetails.data.data.data.debtor.contact !== '' ? orderDetails.data.data.data.debtor.contact : this.clientData.contact_person
        this.clientData.phone = orderDetails.data.data.data.debtor.phoneNumber !== '' ? orderDetails.data.data.data.debtor.phoneNumber : this.clientData.phone
        this.clientData.billing_email = orderDetails.data.data.data.debtor.email !== '' ? orderDetails.data.data.data.debtor.email : this.clientData.email
        this.clientData.bankBranchNo = orderDetails.data.data.data.debtor.bankBranchNo !== '' ? orderDetails.data.data.data.debtor.bankBranchNo : this.clientData.bankBranchNo
        this.clientData.bankAccountNo = orderDetails.data.data.data.debtor.bankAccountNo !== '' ? orderDetails.data.data.data.debtor.bankAccountNo : this.clientData.bankAccountNo
        this.clientData.iban = orderDetails.data.data.data.debtor.iban !== '' ? orderDetails.data.data.data.debtor.iban : this.clientData.iban
        this.clientData.swiftCode = orderDetails.data.data.data.debtor.swiftCode !== '' ? orderDetails.data.data.data.debtor.swiftCode : this.clientData.swiftCode
        this.clientData.loginStatus = typeof orderDetails.data.data.data.client.loginStatus === 'undefined' ? '1' : orderDetails.data.data.data.client.loginStatus
        this.clientData.email = this.clientData.billing_email
        this.clientData.vat_exempted = orderDetails.data.data.data.debtor.vatExemptedClient === '' ? orderDetails.data.data.data.client.vat_exempted : orderDetails.data.data.data.debtor.vatExemptedClient
        this.clientData.bc_creditor_id = typeof orderDetails.data.data.data.client.bc_creditor_id === 'undefined' ? '' : orderDetails.data.data.data.client.bc_creditor_id
        this.clientData.termSheetCode = typeof orderDetails.data.data.data.client.termSheetCode !== 'undefined' ? orderDetails.data.data.data.client.termSheetCode : ''
        this.clientData.order = this.orderData
        if (typeof orderDetails.data.data.data.client.id === 'undefined') {
          this.clientData.username = orderDetails.data.data.data.debtor.customerType === 'Person' ? orderDetails.data.data.data.debtor.cprNo : orderDetails.data.data.data.debtor.taxRegistrationNumber
        } else {
          this.clientData.username = orderDetails.data.data.data.client.username
        }
        this.clientData.address.road_name = typeof orderDetails.data.data.data.client.address === 'undefined' ? '' : orderDetails.data.data.data.client.address.road_name
        this.clientData.address.house_number = typeof orderDetails.data.data.data.client.address === 'undefined' ? '' : orderDetails.data.data.data.client.address.house_number
        this.clientData.address.place = typeof orderDetails.data.data.data.client.address === 'undefined' ? '' : orderDetails.data.data.data.client.address.place
        this.clientData.address.zip_code = typeof orderDetails.data.data.data.client.address === 'undefined' ? '' : orderDetails.data.data.data.client.address.zip_code
        this.clientData.address.city = typeof orderDetails.data.data.data.client.address === 'undefined' ? '' : orderDetails.data.data.data.client.address.city
        this.clientData.address.country_id = typeof orderDetails.data.data.data.client.address === 'undefined' ? 247 : orderDetails.data.data.data.client.address.country_id
        this.clientData.address.road_name = orderDetails.data.data.data.debtor.addressLine1 !== '' ? orderDetails.data.data.data.debtor.road_name : this.clientData.address.road_name
        this.clientData.address.house_number = orderDetails.data.data.data.debtor.addressLine1 !== '' ? orderDetails.data.data.data.debtor.house_number : this.clientData.address.house_number
        this.clientData.address.place = orderDetails.data.data.data.debtor.state !== '' ? orderDetails.data.data.data.debtor.state : this.clientData.address.place
        this.clientData.address.zip_code = orderDetails.data.data.data.debtor.postalCode !== '' ? orderDetails.data.data.data.debtor.postalCode : this.clientData.address.zip_code
        this.clientData.address.city = orderDetails.data.data.data.debtor.city !== '' ? orderDetails.data.data.data.debtor.city : this.clientData.address.city
        this.clientData.address.country_id = orderDetails.data.data.data.debtor.country !== '' ? 247 : this.clientData.address.country_id

        if (!orderDetails.data.data.data.client.billing_address || orderDetails.data.data.data.client.billing_address.length === 0) {
          this.clientData.billing_address = this.billing_address
          this.addBillingAddressBtn = false
          this.clientBillingAddressData = false
        } else {
          this.clientData.billing_address = orderDetails.data.data.data.client.billing_address
        }
        this.loader = false
      }
    },
    async onSubmit() {
      this.loader = true
      const data = { ...this.clientData }
      let validation = false
      if (data.id === 0 || data.id === '') {
        validation = await axios.post('clients/validate-username', { username: data.username })
          .then(() => true).catch(() => false)
      } else {
        validation = await axios.post('clients/validate-username', { username: data.username, exclude: [data.id] })
          .then(() => true).catch(() => false)
      }
      if (!validation) {
        this.validateUsername = validation
        this.loader = false
        return false
      }
      const USER_APP_STORE_MODULE_NAME = 'app-client'

      // Register module
      if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, clientStoreModule)
      // console.log('--->', data)
      store.dispatch('app-client/serviceCall', data)
        .then(() => {
          // console.log('done', response)
          this.$router.replace('/orders')
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Client Updated',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: 'Service Call Completed!',
                },
              })
            })
        })
        .catch(error => {
          this.alertErrors = []
          this.alertErrors.push(...error.data.message)
          // console.log('error**', this.alertErrors)
          this.loader = false
        })
      return true
    },
    deleteOrder() {
      this.modalLoader = true
      this.modalLoader = false
    },
    getTermsheetCodes() {
      this.termSheetCodeLoader = true
      axios.get('/settings/termsheetcode-dropdown').then(response => {
        if (response.status === 200) {
          const termsheetCodes = response.data.data
          this.termSheetCodeOptions = termsheetCodes
          this.termSheetCodeLoader = false
        }
      })
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
